module.exports = __webpack_public_path__ + "ae12f8e32c94fc044e600bf95178f265.pdf";